import {
  type BaseQueryFn,
  createApi,
  fetchBaseQuery,
  type FetchArgs,
  type FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'

import { clearAuth } from '../slices/authSlice'
import { getStoredToken, setStoredToken } from '@/services/auth'
import { API_BASE_URL } from '@/config/api'

const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers) => {
    const token = getStoredToken()
    if (token) headers.set('authorization', `Bearer ${token}`)
    return headers
  },
})

// N2NAI §3.5 — auto-logout khi 401
const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extra,
) => {
  const result = await rawBaseQuery(args, api, extra)
  if (result.error && result.error.status === 401) {
    setStoredToken(null)
    api.dispatch(clearAuth())
    if (window.location.pathname !== '/login') {
      window.location.href = '/login'
    }
  }
  return result
}

export const baseApi = createApi({
  reducerPath: 'tlcerpApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'Auth',
    'User',
    'Role',
    'Vendor',
    'Bank',
    'LocalP',
    'LocalPDetail',
    'ContractAll',
    'Lookup',
    'LocalPPlan',
    'LocalPForward',
    'LocalPVer2',
    'PTBFFixation',
    'PTBFRolling',
    'NPEContract',
    'NPEFixation',
    'NPEAlloc',
    'FactoryBaoLoc',
  ],
  endpoints: () => ({}),
})
